module.exports = __webpack_public_path__ + "img/Download Icon - charcoal.b6ea1d7e.svg";